<script>
import { mapGetters } from 'vuex'
import Filter from './Filter'
export default {
    name: 'Balance',

    computed: {
        ...mapGetters({
            transactions: 'transactions',
            transformed: 'transactionsTransformed',
            filters: 'filters',
            search: 'search',
            authUser: 'authUser',
        }),
    },

    watch: {
        $route: 'fetch',
        search: 'fetch',
        filters: 'fetch',
    },

    mounted() {
        this.fetch()
        this.$store.dispatch('filterComponent', Filter)
    },

    methods: {
        fetch() {
            const userId = this.filters.user_id
                ? this.filters.user_id
                : this.authUser.id
            this.$store.dispatch('transactionsFetch', {
                id: userId,
                search: this.search,
                filters: this.filters,
            })
        },
    },
}
</script>
<template lang="pug">
acrm-panel(transparent)
    div.flex-center-v.w-100.flex-wrap.flex-md-nowrap(slot="heading")
        acrm-avatar.mr-3(:name="transactions.user.display_name" medium)
        .d-inline-block
            acrm-heading(:level="4").mb-0 {{ transactions.user.display_name }}
            label {{ transactions.user.email }}
        acrm-input-button.ml-auto(variant="secondary" icon="file_download" link) {{ $t('BALANCE.XLSX')}}
    .row.mb-4
        .col-24.col-sm-12.col-lg-7.mb-3.mb-lg-0
            .d-flex.justify-content-between
                label {{ $t('BALANCE.ACT_BALANCE')}}
                acrm-input-button.btn-sm.c-primary-2.ml-auto(variant="link" icon="file_upload" @click="$refs.balanceModal.open()") {{ $t('BALANCE.UPLOAD')}}
            acrm-heading(:level="4").mb-1 {{ transactions.user.balance | toMoney }}
            acrm-balance-enough(:balance="transactions.user.balance")
        .col-24.col-sm-12.col-lg-5.col-xl-4.mb-3.mb-lg-0
            label {{ $t('BALANCE.NET_PROFIT')}}
            acrm-heading(:level="4").mb-1 {{ transactions.user.balance | toMoney }}
        .col-24.col-sm-12.col-lg-5.col-xl-4.mb-3.mb-lg-0
            label {{ $t('BALANCE.COMPANY_BALANCE')}}
            acrm-heading(:level="4").mb-1 {{ transactions.user.balance | toMoney }}
            small.d-block Atransfer
        .col-24.col-sm-12.col-lg-5.col-xl-4.mb-3.mb-lg-0
            label {{ $t('BALANCE.ACRM_PROFIT')}}
            acrm-heading(:level="4").mb-1 {{ transactions.user.balance | toMoney }}

    .separator-bottom.mb-4

    table.table.table-striped.table-hover(v-for="x in transformed" :key="x.id")
        thead
            tr.row-info
                th.text-transform-none
                    .row.no-gutters
                        .col-24.col-sm-16.col-md-auto.flex-center-v
                            .row.no-gutters
                                .col-24.col-md-auto
                                    label.c-primary-2.mr-4(v-if="x.order") {{ x.order.oid }}
                                    label.c-dark-4.mr-4(v-if="!x.order") Befizetés
                                    span.mr-4(v-if="x.order && x.order.order_status") {{ x.order.order_status.translated }}
                                    .mt-2.d-sm-none
                                .col-24.col-md-auto(v-if="false")
                                    span.mr-2.c-dark-4 {{ $t('BALANCE.CON_ORDERS')}}
                                    span.mr-2.c-primary-2 W004013
                                    span.mr-2.c-primary-2 L003214
                                    span.mr-2.c-primary-2 A006546
                        .col-24.col-sm.col-md.flex-center-v
                            acrm-badge.ml-auto.block-xs.mt-2.mt-sm-0(:variant=" x.to_type == null ? 'danger' : 'success'" lg)
                                span.c-white
                                    template(v-if="x.to_type == null")
                                    | {{ x.sum | toMoneyFrac }}
        tbody
            tr(v-if="!x.sub || x.sub.length == 0")
                td
                    .row
                        .col-24.col-sm-16.col-xl-8.flex-center-v.flex-mobile-wrap
                            span.break-all.font-weight-bold {{ x.id }}
                        .col-auto.col-sm-8.col-xl-5.flex-center-v.justify-content-end {{ x.created_at | toDateTime }}
                        .col-auto.col-sm-8.col-xl-4.flex-center-v.flex-mobile-wrap
                            span.c-dark-4 {{ x.comment }}
                        .col-auto.col-sm-8.col-xl-4.flex-center-v.justify-content-center.justify-content-xl-start.flex-mobile-wrap
                            span.c-primary-2
                                template(v-if="x.from") {{ x.from_name }}
                                template(v-else) CRM
                            icon.mr-1.ml-1(name="arrow_forward")
                            span.c-primary-2
                                template(v-if="x.to") {{ x.to_name }}
                                template(v-else) CRM
                        .col-auto.col-sm-8.col-xl-3.flex-center-v.justify-content-end.flex-mobile-wrap
                            acrm-badge.ml-auto.block-xs.mt-2.mt-sm-0(:variant=" x.to_type == null ? 'danger' : 'success'" lg)
                                span.c-white
                                    template(v-if="x.to_type == null") -
                                    | {{ x.value | toMoneyFrac }}
            tr(v-for="y in x.sub" :key="y.id")
                td
                    .row
                        .col-24.col-sm-16.col-xl-8.flex-center-v.flex-mobile-wrap
                            span.break-all.font-weight-bold {{ y.id }}
                        .col-auto.col-sm-8.col-xl-5.flex-center-v.justify-content-end {{ y.created_at | toDateTime }}
                        .col-auto.col-sm-8.col-xl-4.flex-center-v.flex-mobile-wrap
                            span.c-dark-4 {{ y.comment }}
                        .col-auto.col-sm-8.col-xl-4.flex-center-v.justify-content-center.justify-content-xl-start.flex-mobile-wrap
                            span.c-primary-2
                                template(v-if="y.from") {{ y.from_name }}
                                template(v-else) CRM
                            icon.mr-1.ml-1(name="arrow_forward")
                            span.c-primary-2
                                template(v-if="y.to") {{ y.to_name }}
                                template(v-else) CRM
                        .col-auto.col-sm-8.col-xl-3.flex-center-v.justify-content-end.flex-mobile-wrap
                            acrm-badge.ml-auto.block-xs.mt-2.mt-sm-0(:variant=" y.to_type == null ? 'danger' : 'success'" lg)
                                span.c-white
                                    template(v-if="y.to_type == null") -
                                    | {{ y.value | toMoneyFrac }}
    acrm-modal-balance(:user="transactions.user.display_name" ref="balanceModal")
</template>
